






import Vue from 'vue'

export default Vue.extend({
  name: 'LoadingPlaceholder',
  props: {
    lines: {
      type: Number,
      default: 3,
    },
  },
})
